module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTrack) ? _c('div', [_c('Tracking', {
    attrs: {
      "track": _vm.tracking,
      "firstName": _vm.firstName,
      "document": _vm.document,
      "showBack": _vm.showBack,
      "account": _vm.account.code,
      "isOrder": true,
      "orderNumber": _vm.orderNumber,
      "parameters": _vm.parameters
    },
    on: {
      "hiddenTrack": _vm.hiddenTrack
    }
  })], 1) : _c('div', {
    staticStyle: {
      "margin-top": "-70px"
    }
  }, [(_vm.showModalExport) ? _c('transition', {
    attrs: {
      "id": "exportar",
      "name": "exportar"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v("Exportar Reporte")])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.closeExport()
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('p', {
      staticClass: "p-bus",
      staticStyle: {
        "text-align": "left",
        "padding-left": "20px"
      }
    }, [_vm._v("\n                  Indique su correo donde le llegará su reporte con el listado de pedidos:\n                  "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('form', {
      attrs: {
        "autocomplete": "off"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.exportOrder()
        }
      }
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      staticStyle: {
        "font-size": "24px",
        "color": "#3D77FF"
      }
    }, [_c('i', {
      ref: "atrack",
      staticClass: "fa fa-paper-plane a-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fEmail),
        expression: "fEmail"
      }],
      staticClass: "form-control form-control-ora",
      class: {
        'is-invalid': _vm.submitted && (!_vm.fEmail || !_vm.isEmail)
      },
      attrs: {
        "placeholder": "Correo"
      },
      domProps: {
        "value": (_vm.fEmail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.fEmail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.submitted && _vm.fEmail === ''),
        expression: "submitted && fEmail===''"
      }],
      staticClass: "invalid-feedback"
    }, [_vm._v("El correo es requerido")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.submitted && !_vm.isEmail),
        expression: "submitted && !isEmail"
      }],
      staticClass: "invalid-feedback"
    }, [_vm._v("El correo es invalido")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      class: ['btn btn-ora-blue', {
        'disabled': (_vm.submitted && (_vm.fEmail === '' || !_vm.isEmail))
      }],
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n                          Enviar\n                        ")])])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.message.show) ? _c('transition', {
    attrs: {
      "id": "message",
      "name": "message"
    }
  }, [_c('div', {
    staticClass: "modal-cus-mask"
  }, [_c('div', {
    staticClass: "modal-cus-wrapper"
  }, [_c('div', {
    staticClass: "modal-cus-container",
    staticStyle: {
      "width": "450px"
    }
  }, [_c('div', {
    staticClass: "modal-cus-header"
  }, [_vm._t("header", function() {
    return [_c('div', {
      staticClass: "title-boreder"
    }, [_c('div', {
      staticClass: "box-title box-title-sub"
    }, [_c('span', [_vm._v(_vm._s(_vm.message.title))])]), _vm._v(" "), _c('button', {
      staticClass: "close",
      staticStyle: {
        "padding": "5px",
        "position": "relative !important",
        "top": "-35px !important"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.message.show = false
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-cus-body",
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-xs-2",
      class: {
        'msg-info': _vm.message.type === 'info',
        'msg-warn': _vm.message.type === 'warn',
        'msg-error': _vm.message.type === 'error'
      }
    }, [_c('i', {
      ref: "atrack",
      class: {
        'fa fa-info-circle a-icon': _vm.message.type === 'info',
        'fa fa-exclamation-triangle a-icon': _vm.message.type === 'warn',
        'fa fa-window-close a-icon': _vm.message.type === 'error'
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-xs-10 text-left"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_vm._v("                  \n                            " + _vm._s(_vm.message.description) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-3 col-xs-12 text-center"
    }, [_c('button', {
      staticClass: "btn btn-ora-msg",
      class: {
        'btn-ora-msg-info': _vm.message.type === 'info',
        'btn-ora-msg-warn': _vm.message.type === 'warn',
        'btn-ora-msg-error': _vm.message.type === 'error'
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.message.show = false
        }
      }
    }, [_vm._v("\n                        Aceptar\n                      ")])])])])])]
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "-15px !important"
    }
  }, [_c('div', {
    staticClass: "nav-order"
  }, [_vm._m(0), _vm._v(" "), (_vm.existe == 1 && _vm.order.accountLogo != null) ? _c('img', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "src": ("data:image/png;base64," + (_vm.order.accountLogo))
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "doc-filter"
  }, [_c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": function($event) {
        return _vm.showAdvanced()
      }
    }
  }, [_vm._v(" Avanzado")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.CustomerOrderNumber),
      expression: "filter.CustomerOrderNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "type": "text",
      "id": "txtPedido",
      "name": "txtPedido",
      "placeholder": "Nro de Pedido",
      "maxlength": "30",
      "aria-labelledby": "label-pedido"
    },
    domProps: {
      "value": (_vm.filter.CustomerOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "CustomerOrderNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(5), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-layer",
    attrs: {
      "id": "cboTipo",
      "name": "cboTipo",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "track-by": "description",
      "label": "description",
      "placeholder": "Tipo",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderTypeList
    },
    on: {
      "open": function($event) {
        return _vm.reloadTypes()
      }
    },
    model: {
      value: (_vm.filter.OrderType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "OrderType", $$v)
      },
      expression: "filter.OrderType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(6)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(7), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboZona",
      "name": "cboZona",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Zona",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderZoneList
    },
    on: {
      "open": function($event) {
        return _vm.reloadZone()
      }
    },
    model: {
      value: (_vm.filter.Zone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Zone", $$v)
      },
      expression: "filter.Zone"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(8)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(9), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-bar",
    attrs: {
      "id": "cboEstado",
      "name": "cboEstado",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Estado",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderStatusList
    },
    on: {
      "open": function($event) {
        return _vm.reloadStatus()
      }
    },
    model: {
      value: (_vm.filter.Status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Status", $$v)
      },
      expression: "filter.Status"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(10)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Limpiar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_vm._v(" Buscar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.advanced) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.TrackingNumber),
      expression: "filter.TrackingNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "mode": "text",
      "id": "txtTracking",
      "name": "txtTracking",
      "placeholder": "Nro Tracking",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.filter.TrackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "TrackingNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtTracking",
      "id": "label-tracking"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro Tracking")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDepartamento",
      "name": "cboDepartamento",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Departamento",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.departamentList
    },
    on: {
      "input": function($event) {
        return _vm.getProvince()
      },
      "open": function($event) {
        return _vm.reloadDepartament()
      }
    },
    model: {
      value: (_vm.filter.Department),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Department", $$v)
      },
      expression: "filter.Department"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDepartamento",
      "id": "label-departamento"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Departamento")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboProvincia",
      "name": "cboProvincia",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Provincia",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.provinceList
    },
    on: {
      "input": function($event) {
        return _vm.getDistrict()
      },
      "open": function($event) {
        return _vm.reloadProvince()
      }
    },
    model: {
      value: (_vm.filter.Province),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Province", $$v)
      },
      expression: "filter.Province"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboProvincia",
      "id": "label-provincia"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Provincia")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })]), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDistrito",
      "name": "cboDistrito",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Distrito",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.districtList
    },
    on: {
      "open": function($event) {
        return _vm.reloadDistrict()
      }
    },
    model: {
      value: (_vm.filter.District),
      callback: function($$v) {
        _vm.$set(_vm.filter, "District", $$v)
      },
      expression: "filter.District"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDistrito",
      "id": "label-distrito"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Distrito")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-4 pull-center"
  })]) : _vm._e()])], 1)])]) : _c('div', [_c('div', {
    staticClass: "filterContainer",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.CustomerOrderNumber),
      expression: "filter.CustomerOrderNumber"
    }],
    staticClass: "form-control form-control-ora-sin-blank",
    attrs: {
      "mode": "text",
      "id": "txtPedido",
      "name": "txtPedido",
      "placeholder": "Nro de Pedido",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.filter.CustomerOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "CustomerOrderNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/eraser.svg"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/search-solid.svg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.verFiltros()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/filter.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Filtros")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showExport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/excel.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Exportar")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "div-filtro"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showAdvanced()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/filter.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Búsqueda Avanzada")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(14), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-layer",
    attrs: {
      "id": "cboTipo",
      "name": "cboTipo",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Tipo",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderTypeList
    },
    on: {
      "open": function($event) {
        return _vm.reloadTypes()
      }
    },
    model: {
      value: (_vm.filter.OrderType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "OrderType", $$v)
      },
      expression: "filter.OrderType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(15)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(16), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboZona",
      "name": "cboZona",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Zona",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderZoneList
    },
    on: {
      "open": function($event) {
        return _vm.reloadZone()
      }
    },
    model: {
      value: (_vm.filter.Zone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Zone", $$v)
      },
      expression: "filter.Zone"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(17)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(18), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-bar",
    attrs: {
      "id": "cboEstado",
      "name": "cboEstado",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Estado",
      "track-by": "description",
      "label": "description",
      "customLabel": _vm.optDescription,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.orderStatusList
    },
    on: {
      "open": function($event) {
        return _vm.reloadStatus()
      }
    },
    model: {
      value: (_vm.filter.Status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Status", $$v)
      },
      expression: "filter.Status"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(19)], 1)])]), _vm._v(" "), (_vm.advanced) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.TrackingNumber),
      expression: "filter.TrackingNumber"
    }],
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "mode": "text",
      "id": "txtTacking",
      "name": "txtTacking",
      "placeholder": "Nro Tracking",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.filter.TrackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "TrackingNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(21)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(22), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDepartamento",
      "name": "cboDepartamento",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Departamento",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.departamentList
    },
    on: {
      "input": function($event) {
        return _vm.getProvince()
      },
      "open": function($event) {
        return _vm.reloadDepartament()
      }
    },
    model: {
      value: (_vm.filter.Department),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Department", $$v)
      },
      expression: "filter.Department"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(23)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(24), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboProvincia",
      "name": "cboProvincia",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Provincia",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.provinceList
    },
    on: {
      "input": function($event) {
        return _vm.getDistrict()
      },
      "open": function($event) {
        return _vm.reloadProvince()
      }
    },
    model: {
      value: (_vm.filter.Province),
      callback: function($$v) {
        _vm.$set(_vm.filter, "Province", $$v)
      },
      expression: "filter.Province"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(25)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_vm._m(26), _vm._v(" "), _c('multiselect', {
    staticClass: "multiselect-ora multiselect-ora-point",
    attrs: {
      "id": "cboDistrito",
      "name": "cboDistrito",
      "selectLabel": "",
      "selectedLabel": "",
      "deselectLabel": "",
      "placeholder": "Distrito",
      "track-by": "name",
      "label": "name",
      "customLabel": _vm.optName,
      "show-labels": false,
      "close-on-select": true,
      "options": _vm.districtList
    },
    on: {
      "open": function($event) {
        return _vm.reloadDistrict()
      }
    },
    model: {
      value: (_vm.filter.District),
      callback: function($$v) {
        _vm.$set(_vm.filter, "District", $$v)
      },
      expression: "filter.District"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("La lista esta vacia.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No se encontró el elemento buscado.")])]), _vm._v(" "), _vm._m(27)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v(" Limpiar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_vm._v(" Buscar")])])])]) : _vm._e()])]), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "doc-filter"
  }, [_c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_vm._m(28), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-sm btnAction btn-ora btn-ora-auto",
    on: {
      "click": function($event) {
        return _vm.showExport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/excel.svg"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("Exportar")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "resultTable",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "orderType",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.orderType)))])])]
      }
    }, {
      key: "orderNumber",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "min-width": "100px"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.customerOrderNumber))])])]
      }
    }, {
      key: "issueDate",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "min-width": "120px",
            "text-align": "center"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateOnly")(props.rowData.issueDate, "DD/MM/YYYY", true)))])])]
      }
    }, {
      key: "customerName",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.customerName)))])])]
      }
    }, {
      key: "customerAddress",
      fn: function(props) {
        return [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("firstLetter")(props.rowData.customerAddress)))])])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [_c('div', {
          staticClass: "data-status-ora"
        }, [_vm._v("\n                " + _vm._s(_vm._f("firstLetter")(props.rowData.status)) + "\n              ")])]
      }
    }, {
      key: "trackingNumber",
      fn: function(props) {
        return [_c('div', {
          class: {
            'selected-row': _vm.selectIndex === props.rowIndex
          }
        }, [_c('a', {
          staticClass: "data-arrow",
          attrs: {
            "data-toggle": "collapse"
          },
          on: {
            "click": function($event) {
              return _vm.goTracking(props.rowData, props.rowIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-right",
          attrs: {
            "aria-hidden": "true"
          }
        })])])]
      }
    }], null, false, 438030318)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("                \n               \n              "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n                Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 20) + " a " + _vm._s(this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 1)])]) : _c('div', {
    staticStyle: {
      "padding": "20px 5px 20px 5px"
    }
  }, [_vm._m(29), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filterContainer"
  }, [(_vm.tableData.data === null || _vm.tableData.data.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("No se encontraron resultados")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData.data), function(order, index) {
    return _c('div', {
      key: index,
      ref: "detailsitem",
      refInFor: true,
      staticClass: "div-data",
      class: {
        'selected-row-mov': _vm.selectIndex === index
      }
    }, [_c('div', {
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.goTracking(order, index)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Tipo")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.orderType)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Nro. Pedido")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value-limit"
    }, [_vm._v(_vm._s(order.customerOrderNumber))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Fecha Pedido")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(order.issueDate, "DD/MM/YYYY", true)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Nombre del Cliente")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.customerName)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-value"
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.customerAddress)))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 div-data-space"
    }, [_c('div', {
      staticClass: "form-group div-data-bottom"
    }, [_c('label', {
      staticClass: "div-data-title"
    }, [_vm._v("Status")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "div-data-status",
      staticStyle: {
        "color": "#3D77FF"
      }
    }, [_vm._v(_vm._s(_vm._f("firstLetter")(order.status)))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _vm._v(" "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n                  Mostrando documento " + _vm._s(this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (_vm.pageNumber - 1) * 20) + " a " + _vm._s(this.paginationData.to < this.paginationData.per_page ? this.paginationData.total : this.paginationData.to * this.pageNumber) + " de " + _vm._s(this.paginationData.total) + " en Total\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    staticStyle: {
      "float": "none !important"
    },
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 2)])]), _vm._v(" "), (_vm.existe == 0) ? _c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n          No hemos podido encontrar tu pedido\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n          Comunicate con nosotros para brindarte información de tu pedido\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex ati-header"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/search.svg"
    }
  }), _c('span', {
    staticClass: "nav-header-title-label"
  }, [_vm._v("Seguimiento de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/doc-search.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Buscar Documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/calendar.svg"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "id": "dtDateRange",
      "name": "dtDateRange",
      "mode": "text",
      "placeholder": "Fecha Pedido",
      "aria-labelledby": "label-fecha",
      "readOnly": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "dtDateRange",
      "id": "label-fecha"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Fecha Pedido")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtPedido",
      "id": "label-pedido"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/layers.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboTipo",
      "id": "label-tipo"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Tipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboZona",
      "id": "label-zona"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Zona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/bar.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboEstado",
      "id": "label-estado"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    staticClass: "ico-seach-input",
    attrs: {
      "src": "/static/img/svg/search-solid.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtPedido",
      "id": "label-pedido"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro de Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group input-group-ora"
  }, [_c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/calendar.svg"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-ora-sin",
    attrs: {
      "id": "dtDateRange",
      "name": "dtDateRange",
      "placeholder": "Fecha Pedido",
      "mode": "text",
      "readOnly": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "dtDateRange",
      "id": "label-fecha"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Fecha Pedido")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/layers.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboTipo",
      "id": "label-tipo"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Tipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboZona",
      "id": "label-zona"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Zona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/bar.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboEstado",
      "id": "label-estado"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Estado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/hash.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "txtTacking",
      "id": "label-tracking"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Nro Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDepartamento",
      "id": "label-departamento"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Departamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboProvincia",
      "id": "label-provincia"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Provincia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon input-group-addon-ico",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/zone.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-ora",
    attrs: {
      "for": "cboDistrito",
      "id": "label-distrito"
    }
  }, [_c('div', {
    staticClass: "text-ora"
  }, [_vm._v("Distrito")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ati-flex ati-pb"
  }, [_c('div', {
    staticClass: "ati-flex"
  }, [_c('div', {
    staticClass: "title-filter"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/svg/list.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label-filter"
  }, [_vm._v("Pedidos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e816200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tracking/OrderSearch.vue
// module id = 525
// module chunks = 1